// extracted by mini-css-extract-plugin
export default {"price":"SummaryAppBar_price__8QfOO"};